import React, { createContext, useContext, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Mapping from './pages/Mapping';
import SyncLogs from './pages/SyncLogs';
import Gatekeeper from './pages/Gatekeeper';
import Onboarding from './pages/Onboarding';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import './styles/global.css';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Set auth header immediately on page load
const savedToken = localStorage.getItem('token');
if (savedToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
}

export const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [connections, setConnections] = useState({ procore: false, quickbooks: false });

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    if (savedToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
      checkConnections();
    }
  }, [token]);

  const checkConnections = async () => {
    try {
      const res = await axios.get('/auth/status');
      setConnections(res.data);
    } catch {}
  };

  const login = (newToken) => {
    localStorage.setItem('token', newToken);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, login, logout, connections, checkConnections }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!token ? <Login /> : <Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
          <Route path="/mapping" element={token ? <Mapping /> : <Navigate to="/login" />} />
          <Route path="/logs" element={token ? <SyncLogs /> : <Navigate to="/login" />} />
          <Route path="/gatekeeper" element={token ? <Gatekeeper /> : <Navigate to="/login" />} />
          <Route path="/onboarding" element={token ? <Onboarding /> : <Navigate to="/login" />} />
          <Route path="/profile" element={token ? <Profile /> : <Navigate to="/login" />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to={token ? '/dashboard' : '/login'} />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
